// extracted by mini-css-extract-plugin
export default {"noContentRow":"TableRowNoRecords_noContentRow__6zNba","noContentCell":"TableRowNoRecords_noContentCell__tDYxV"};